<template>
    <div>
        <h5>Manage Sources</h5>
        <div>
            <Toolbar v-if="authStore.hasPermission(UserPermission.WRITE_SOURCE)" class="mb-4 card">
                <template v-slot:start>
                    <div class="my-2">
                        <Button label="Add Source" icon="pi pi-plus" class="p-button-success mr-2" @click="dialogForm = true" />
                    </div>
                </template>
            </Toolbar>
        </div>

        <!-- create source form -->
        <source-form v-if="dialogForm" @hide-dialog="dialogForm = false" />

        <!-- source table -->
        <source-table class="card" />
    </div>
</template>

<script setup>
import SourceForm from '../modules/SourceForm';
import SourceTable from '../modules/SourceTable.vue';
import { ref } from 'vue';
import { authStore } from '../../../../../store/global-stores';
import { UserPermission } from '../../../../../modules/permission/enum';
const dialogForm = ref(false);
</script>
